import { useState, useEffect } from "react";
import Style from "./PlansDetailStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import { AxiosRequestConfig } from "axios";
import api from "../../services/api";
import VariationPlans from "./Variations/VariationPlansList";
import PageTitle from "../../components/PageTitle";
import { CentsToHuman, CurrencyToCents, GetFileFromURL, StringToBool } from "../../utils";
import { InputImage } from "../../components/InputImage/InputImage";
import InfoModal from "../../shared/Bootstrap/InfoModal";
import InputCurrency from "../../components/Buttons/InputCurrency";
import { GenericInputFileWithPreview } from "../../components/GenericInputFileWithPreview/GenericInputFileWithPreview";

export default function PlansDetail(props) {
  const [name, setName] = useState("");
  const [sceneName, setSceneName] = useState("");
  const [hasZoom, setHasZoom] = useState("" as any);

  const [artValue, setArtValue] = useState<string>("R$ 0,00");
  const [cleaningTaxValue, setCleaningTaxValue] = useState("R$ 0,00");

  const [selectedImage, setSelectedImage] = useState({} as File);
  const [selectedTechnicalPlan, setSelectedTechnicalPlan] = useState(
    {} as File
  );
  const [selectedDetailedPlan, setSelectedDetailedPlan] = useState({} as File);
  const [imageUrl, setImageUrl] = useState("");
  const [technicalPlanUrl, setTechnicalPlanUrl] = useState("");
  const [detailedPlanUrl, setDetailedPlanUrl] = useState("");

  const [selectedAssetBundle, setSelectedAssetBundle] = useState({} as File);
  const [assetBundleUrl, setAssetBundleUrl] = useState("");
  const [deleteAssetBundle, setDeleteAssetBundle] = useState(false);


  const [deleteImage, setDeleteImage] = useState(false);
  const [deleteTechnicalPlan, setDeleteTechnicalPlan] = useState(false);
  const [deleteDetailedPlan, setDeleteDetailedPlan] = useState(false);
  const [variations, setVariations] = useState([] as any);
  const [variationToDelete, setVariationToDelete] = useState({} as any);
  const [deletingVariation, setDeletingVariation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const planId = props.match.params.planId;
  const creatingNew = planId <= 0;

  useEffect(() => {
    if (!creatingNew) LoadPlan(planId);
  }, []);

  async function LoadPlan(planId) {
    try {
      setLoading(true);
      const result = await api.get(`/plans/${planId}`);
      if (result.data.success) {
        let plan = result.data.plan;
        setName(plan.name);
        setSceneName(plan.sceneName);
        setHasZoom(StringToBool(plan.hasZoom));
        setArtValue(CentsToHuman(plan.artValue));
        setCleaningTaxValue(CentsToHuman(plan.cleaningTaxValue));
        setImageUrl(plan.image);
        setTechnicalPlanUrl(plan.technicalPlanImage);
        setDetailedPlanUrl(plan.detailedPlanImage);
        setAssetBundleUrl(plan.assetBundle);
        setLoading(false);
        setVariations(plan.variations);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  async function OnSubmit() {
    try {
      setLoading(true);
      onClosePopup();
      const options: AxiosRequestConfig = {};
      const formData = new FormData();
      if (selectedImage.name && !deleteImage) {
        formData.append("image", selectedImage, selectedImage.name);
      }
      if (selectedTechnicalPlan.name && !deleteTechnicalPlan) {
        formData.append(
          "technicalPlanImage",
          selectedTechnicalPlan,
          selectedTechnicalPlan.name
        );
      }
      if (selectedDetailedPlan.name && !deleteDetailedPlan) {
        formData.append(
          "detailedPlanImage",
          selectedDetailedPlan,
          selectedDetailedPlan.name
        );
      }

      console.log("Selected asset bundle: ", selectedAssetBundle);
      if (selectedAssetBundle.name && !deleteAssetBundle) {
        formData.append(
          "assetBundle",
          selectedAssetBundle,
          selectedAssetBundle.name
        );
      }

      if (!creatingNew) {
        formData.append("deleteImage", deleteImage.toString());
        formData.append("deleteTechnicalPlan", deleteTechnicalPlan.toString());
        formData.append("deleteDetailedPlan", deleteDetailedPlan.toString());
        formData.append("deleteAssetBundle", deleteAssetBundle.toString());
      }
      formData.append("name", name);
      formData.append("sceneName", sceneName);
      formData.append("hasZoom", hasZoom);
      formData.append("artValue", CurrencyToCents(artValue).toString());
      formData.append("cleaningTaxValue", CurrencyToCents(cleaningTaxValue).toString());


      await (creatingNew
        ? api.post(`/plans`, formData, options)
        : api.put(`/plans/${planId}`, formData, options));
      if (creatingNew) {
        props.history.goBack();
      } else {
        setShowSuccessPopup(true);
        setSelectedAssetBundle({} as File);
        setDeleteAssetBundle(false);
        LoadPlan(planId);
      }
    } catch (error: any) {
      console.error("Erro no request: ", error);
      if (error.message === "Network Error" && !error.response)
        setMessageError("Falha ao enviar: provavelmente arquivo muito grande.");
      else
        setMessageError(error?.response?.data?.message);
    } finally {
      setLoading(false);
      onClosePopup();
    }
  }

  function onOpenPopUp() {
    setShowPopup(true);
  }
  function onClosePopup() {
    setShowPopup(false);
  }
  function onChangeImage(event) {
    setSelectedImage(event.target.files[0]);
    setDeleteImage(false);
  }
  function OnChangeTechnicalPlan(event) {
    setSelectedTechnicalPlan(event.target.files[0]);
    setDeleteTechnicalPlan(false);
  }
  function OnChangeDetailedPlan(event) {
    setSelectedDetailedPlan(event.target.files[0]);
    setDeleteDetailedPlan(false);
  }

  function OnChangeAssetBundle(event) {
    setSelectedAssetBundle(event.target.files[0]);
    setDeleteAssetBundle(false);
  }

  function OnRemoveAssetBundle() {
    //Se ja tiver um asset bundle, remover, se não tiver e tiver remoto, marcar para remover remoto
    //No momento não é deletado remoto pois não havia necessidade
    if (selectedAssetBundle?.name) {
      setSelectedAssetBundle({} as File);
      return;
    }
    else if (assetBundleUrl) {
      setDeleteAssetBundle(true);
    }
  }


  function GetImageUrl(): string {
    return GetFileFromURL(
      imageUrl,
      `${process.env.REACT_APP_BASE_URL}/plans/${planId}/image`
    );
  }
  function GetTechnicalImageUrl(): string {
    return GetFileFromURL(
      technicalPlanUrl,
      `${process.env.REACT_APP_BASE_URL}/plans/${planId}/technicalPlanImage`
    );
  }
  function GetDetailedImageUrl(): string {
    return GetFileFromURL(
      detailedPlanUrl,
      `${process.env.REACT_APP_BASE_URL}/plans/${planId}/detailedPlanImage`
    );
  }

  function ShowConfirmDeletion() {
    return (
      <TwoButtonsModal
        show={variationToDelete.id != null}
        onHide={ClosePopupDeletingVariation}
        loading={false}
        title="Deleção de variação!"
        body={`Você está tentando deletar a variação "${variationToDelete.name}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeletingVariation}
        secondaryDisabled={deletingVariation}
        primaryText="Deletar"
        primaryOnClick={DeleteVariation}
        primaryDisabled={deletingVariation}
      />
    );
  }

  async function DeleteVariation() {
    setDeletingVariation(true);
    try {
      const result = await api.delete(
        `/plans/variations/${variationToDelete.id}`
      );
      if (result.data.success) {
        //setMessageError({ success: "Variação deletada com sucesso!", error: "" });
        LoadPlan(planId);
      } else {
        setMessageError("Problema ao deletar a variação: " + result.data);
        setLoading(false);
      }
    } catch (error: any) {
      setMessageError(error?.response?.data?.message);
      setLoading(false);
    } finally {
      setDeletingVariation(false);
      ClosePopupDeletingVariation();
    }
  }
  function ClosePopupDeletingVariation() {
    setVariationToDelete({});
  }
  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Planta editada com sucesso!"
        body="Suas edições foram salvas com sucesso!"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    );
  }

  return (
    <Style className="default-page">
      {ShowConfirmDeletion()}
      {ShowSuccessPopup()}
      <PageTitle title="Detalhes da Planta" />
      <TwoButtonsModal
        show={showPopup}
        onHide={onClosePopup}
        loading={false}
        title={planId !== undefined ? "Editar Planta" : " Cadastrar Planta"}
        body={
          "Você tem certeza que deseja " +
          (planId !== undefined
            ? "editar esta planta?"
            : " Cadastrar esta planta?")
        }
        secondaryText="Fechar"
        secondaryOnClick={onClosePopup}
        secondaryDisabled={loading}
        primaryText="Confirmar"
        primaryOnClick={() => OnSubmit()}
        primaryDisabled={loading}
      />
      <div className="plans">
        <div>
          <button
            onClick={() => props.history.goBack()}
            className=" btn-secondary return-button"
          >
            Voltar
          </button>
        </div>
        <Spinner spinning={loading} />
        {messageError && (
          <p className="alert alert-error">Erro: {messageError}</p>
        )}
        <main className="default-main">
          <div className="panel">
            <form
              className="main-form"
              onSubmit={(e) => {
                e.preventDefault();
                OnSubmit();
              }}
            >
              <h2>{creatingNew ? "Criação" : "Edição"} de Planta</h2>
              <div>
                <label>Nome:</label>
                <input
                  disabled={loading}
                  defaultValue={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div>
                <label>Nome da cena:</label>
                <input
                  disabled={loading}
                  defaultValue={sceneName}
                  onChange={(e) => setSceneName(e.target.value)}
                />
              </div>

              <div>
                <InputCurrency
                  label="Valor de ART:"
                  id="artValue"
                  disabled={false}
                  value={artValue || "R$ 0,00"}
                  OnChange={(price) => setArtValue(price)}
                />

              </div>
              <div>
                <InputCurrency
                  label="Taxa de limpeza:"
                  id="cleaningTaxValue"
                  disabled={false}
                  value={cleaningTaxValue || "R$ 0,00"}
                  OnChange={(price) => setCleaningTaxValue(price)}
                />

                <label>Taxa de Limpeza:</label>
                <input
                  disabled={loading}
                  defaultValue={sceneName}
                  onChange={(e) => setSceneName(e.target.value)}
                />
              </div>


              <div>
                <label>Zoom:</label>
                <div className="checkbox">
                  <input
                    type="checkbox"
                    disabled={loading}
                    checked={hasZoom}
                    onChange={(e) => setHasZoom(e.target.checked)}
                  />
                </div>
              </div>
              <div>
                <label>Imagem:</label>
                <InputImage
                  id="Image"
                  name="image"
                  label=""
                  alt="Imagem da planta"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetImageUrl()}
                  OnChange={onChangeImage}
                  OnRemove={() => setDeleteImage(true)}
                  image={selectedImage}
                />
              </div>
              <div>
                <label>Planta Técnica:</label>
                <InputImage
                  id="technicalPlan"
                  name="technicalPlan"
                  label=""
                  alt="Imagem da Planta Técnica"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetTechnicalImageUrl()}
                  OnChange={OnChangeTechnicalPlan}
                  OnRemove={() => setDeleteTechnicalPlan(true)}
                  image={selectedTechnicalPlan}
                />
              </div>
              <div>
                <label>Planta Detalhada:</label>
                <InputImage
                  id="detailedPlan"
                  name="detailedPlan"
                  label=""
                  alt="Imagem da Planta Técnica"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetDetailedImageUrl()}
                  OnChange={OnChangeDetailedPlan}
                  OnRemove={() => setDeleteDetailedPlan(true)}
                  image={selectedDetailedPlan}
                />
              </div>

              {/* Arquivos de asset bundle */}

              <div>
                <label>Asset Bundle:</label>
                <GenericInputFileWithPreview
                  id="assetBundle"
                  name="assetBundle"
                  label="Arquivo"
                  alt="AssetBundle da cena da planta"
                  acceptedMimeTypes="*/*"
                  fileUrl={assetBundleUrl}
                  file={selectedAssetBundle}
                  deleted={deleteAssetBundle}
                  OnChange={OnChangeAssetBundle}
                  OnRemove={OnRemoveAssetBundle}
                />
              </div>

              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={name === ""}
                onClick={(e) => {
                  e.preventDefault();
                  onOpenPopUp();
                }}
              >
                {creatingNew ? "Cadastrar" : "Editar"}
              </button>
            </form>
          </div>
          {!creatingNew && (
            <VariationPlans
              planId={planId}
              variations={variations}
              history={props.history}
              disabled={planId === undefined}
              onClickDeleteVariation={(variation) =>
                setVariationToDelete(variation)
              }
            />
          )}
        </main>
      </div>
    </Style>
  );
}
